import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import DownloadIcon from "@mui/icons-material/Download";
import type { RunLogEntry } from "./useCompetitorLinkRemovalDetail";
import { IfPermission } from "../../auth/IfPermission";

interface RunLogPanelProps {
  logs: RunLogEntry[];
  onDownloadLog: () => void;
}

export function RunLogPanel(props: RunLogPanelProps) {
  return (
    <Box mb={3}>
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
        <Typography variant="h6">Лог процесса</Typography>
        <IfPermission permission="competitor-link-removals.export">
          <Button
            size="small"
            startIcon={<DownloadIcon />}
            onClick={props.onDownloadLog}
            disabled={props.logs.length === 0}
          >
            Скачать лог
          </Button>
        </IfPermission>
      </Box>
      {props.logs.length === 0 ? (
        <Typography color="text.secondary">Лог пока пуст.</Typography>
      ) : (
        <Paper variant="outlined" sx={{ maxHeight: 300, overflow: "auto", p: 1 }}>
          {[...props.logs].reverse().map((log, index) => (
            <Typography
              key={`${log.createdAt}-${index}`}
              variant="body2"
              fontFamily="monospace"
              fontSize={12}
              py={0.25}
            >
              <Typography component="span" color="text.secondary" fontSize="inherit" fontFamily="inherit">
                [{new Date(log.createdAt).toLocaleTimeString()}]
              </Typography>{" "}
              {log.message}
            </Typography>
          ))}
        </Paper>
      )}
    </Box>
  );
}
